var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnimatedSeal = function SvgAnimatedSeal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1207,
    height: 983,
    viewBox: "0 0 1207 983",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 69.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#4752be",
    strokeWidth: 140,
    strokeLinecap: "round",
    d: "M563,844h815"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "d",
    begin: "0s",
    dur: "1.5s",
    repeatCount: 1,
    values: "M563,844h815; M278,844h284.579; M278,844h284.579;",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#42bbfc",
    strokeWidth: 140,
    strokeLinecap: "round",
    d: "M578,563h908"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "d",
    begin: "0s",
    dur: "1s",
    repeatCount: 1,
    values: "M578,563h908;M422,563h446.409;M422,563h446.409;",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3cb678",
    strokeWidth: 140,
    strokeLinecap: "round",
    d: "M144,563h1067"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "d",
    begin: "0s",
    dur: "2s",
    repeatCount: 1,
    values: "M144,563h1067; M0,563h138.691; M0,563h138.691;",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ff322f",
    strokeWidth: 140,
    strokeLinecap: "round",
    d: "M927,282h358"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "d",
    begin: "0s",
    dur: "1s",
    repeatCount: 1,
    values: "M927,282h358; M55,282H697.99; M55,282H697.99",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e85d95",
    strokeWidth: 140,
    strokeLinecap: "round",
    d: "M882,1h356"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "d",
    begin: "0s",
    dur: "1.5s",
    repeatCount: 1,
    values: "M882,1h356; M698,1h368.751; M698,1h368.751",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffce00",
    strokeWidth: 140,
    strokeLinecap: "round",
    d: "M787,1h14"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "d",
    begin: "0s",
    dur: "1.5s",
    repeatCount: 1,
    values: "M787,1h14; M278,1h144.251; M278,1h144.251;",
    calcMode: "spline",
    keySplines: "0.4 0 0.2 1; 0.4 0 0.2 1"
  })))));
};
export default SvgAnimatedSeal;